<template>
    <ChannelBackendEntityAssociationCmp 
        :association-service="associationService"
        :entity-plural="entityPlural" 
        :one-to-one="false"
        :allow-export-enabled="false" /> 
</template>

<script>
import ChannelBackendEntityAssociationCmp from '@/utils/components/ChannelBackendEntityAssociationCmp'
import deliveryCompanyService from '@/delivery_company/services/DeliveryCompanyService'

export default {
    name: 'ChannelDeliveryCompanyListAssociationView',
    components: {
        ChannelBackendEntityAssociationCmp,
    },
    data() {
        return {
            associationService: deliveryCompanyService,
            entityPlural: "transportadoras",
        }
    },
}
</script>
